import { useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Mail, CheckCircle, Loader2 } from "lucide-react";
import { toast } from "sonner";

const NewsletterSignup = () => {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState<"idle" | "loading" | "success">("idle");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const trimmed = email.trim();
    if (!trimmed || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmed)) {
      toast.error("Please enter a valid email address.");
      return;
    }

    setStatus("loading");
    const { error } = await supabase
      .from("newsletter_subscribers")
      .insert({ email: trimmed.toLowerCase() });

    if (error) {
      if (error.code === "23505") {
        // duplicate
        setStatus("success");
      } else {
        toast.error("Something went wrong. Please try again.");
        setStatus("idle");
      }
      return;
    }
    setStatus("success");
  };

  if (status === "success") {
    return (
      <div className="rounded-2xl border border-primary/20 bg-gradient-to-br from-primary/10 to-primary/5 p-8 text-center">
        <CheckCircle className="w-8 h-8 text-primary mx-auto mb-3" />
        <h3 className="font-heading text-lg font-bold text-foreground mb-1">You're on the list!</h3>
        <p className="text-sm text-muted-foreground">We'll send you MS energy tips and let you know when invite spots open up.</p>
      </div>
    );
  }

  return (
    <div className="rounded-2xl border border-primary/20 bg-gradient-to-br from-primary/10 to-primary/5 p-8 text-center">
      <Mail className="w-8 h-8 text-primary mx-auto mb-3" />
      <h3 className="font-heading text-lg font-bold text-foreground mb-1">
        Get MS Energy Tips & Early Invite Access
      </h3>
      <p className="text-sm text-muted-foreground mb-5 max-w-sm mx-auto">
        Join the waitlist for invite-only access and get our best fatigue-management strategies delivered weekly.
      </p>
      <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto">
        <Input
          type="email"
          placeholder="you@example.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="rounded-xl flex-1"
          required
        />
        <Button type="submit" disabled={status === "loading"} className="rounded-xl px-6">
          {status === "loading" ? <Loader2 className="w-4 h-4 animate-spin" /> : "Subscribe"}
        </Button>
      </form>
      <p className="text-[11px] text-muted-foreground mt-3">No spam. Unsubscribe anytime.</p>
    </div>
  );
};

export default NewsletterSignup;
